import {ArticleSections} from './ArticleSections';
export default ArticleSections;
